

















import { Mobile } from "@/mixins/mobile";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import SurchargeBanner from "@/components/footer/SurchargeBanner.vue";

@Component({ components: { SurchargeBanner } })
export default class ReviewFooter extends mixins(Mobile) {
  protected submitQuote(): void {
    this.$emit("submit");
  }
}
